Namespace 'Monitoring.Views.SocialContents.Filters'

class Monitoring.Views.SocialContents.Filters.AppliedPostChannelsView extends Backbone.View

  template: JST["backbone/templates/monitoring/filters/vue/common_template"]

  initialize: (@options = {}) ->
    @searchQuery = @options.searchQuery
    selectedProvider = @options.selectedProvider

    @vueChannelsAppliedFilter = new VueInBackbone.VueComponent(
      'channels-applied-filter',
      {
        searchQuery: @searchQuery.toJSON(),
        texts: {
          title: I18n.t('monitoring.publications_session.channel')
        },
        selectedProvider: selectedProvider
      }
    )

  render: ->
    @$el.html(@template)
    @$el.find('.filters-vue-common-template').html(@vueChannelsAppliedFilter.el)
    @vueChannelsAppliedFilter.render()

    @

  destroy: ->
    @vueChannelsAppliedFilter.remove()
    @remove()
